import { createLazyFileRoute } from "@tanstack/react-router";

import { EditWorkflowPage } from "@/features/admin/routes/WorkflowsEdit";

export const Route = createLazyFileRoute("/_auth/admin/workflows/$id/edit")({
  component: () => {
    const params = Route.useParams();
    return <EditWorkflowPage id={params.id} />;
  },
});
